module.exports = __webpack_public_path__ + "img/menu4.5c851e08.png";